import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Printer } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { mktApi } from './marketingApi';
import MonthlyInvoiceSheet from './MonthlyInvoiceSheet';
import QuotationSheet from './QuotationSheet';
import ReceiptSheet from './ReceiptSheet';

export default function DocPrint() {
  const { docId } = useParams();
  const navigate = useNavigate();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    mktApi.document(docId).then(setDoc).catch(() => setErr(true));
  }, [docId]);

  const doPrint = useCallback(() => {
    try { window.focus(); } catch { /* noop */ }
    requestAnimationFrame(() => {
      try { window.print(); } catch { /* noop */ }
    });
  }, []);

  useEffect(() => {
    if (!doc) return;
    const t = setTimeout(doPrint, 700);
    return () => clearTimeout(t);
  }, [doc, doPrint]);

  return (
    <div className="min-h-screen bg-zinc-100 py-6 print:py-0 print:bg-white">
      <div className="no-print max-w-[210mm] mx-auto px-4 mb-4 flex items-center justify-between">
        <Button variant="outline" size="sm" onClick={() => navigate(-1)} data-testid="mkt-print-back-btn"><ArrowLeft size={15} className="mr-1.5" /> 戻る</Button>
        <Button size="sm" onClick={doPrint} data-testid="mkt-print-now-btn" className="bg-teal-700 hover:bg-teal-800"><Printer size={15} className="mr-1.5" /> 印刷</Button>
      </div>
      {err ? <p className="text-center text-sm text-zinc-500 py-20">書類が見つかりません</p>
        : doc?.doc_type === 'monthly_invoice' ? <MonthlyInvoiceSheet doc={doc} />
        : doc?.doc_type === 'receipt' ? <ReceiptSheet doc={doc} /> : <QuotationSheet doc={doc} />}
    </div>
  );
}
